import config from '../config';

const apiUrl = config.apiUrl;

export const CAPTCHA_ERROR_CODE = 'captcha-verification-failed';

/**
 * Captcha is on for an environment exactly when a site key is configured.
 * Without one the widget renders nothing and this check is skipped.
 */
export const isCaptchaEnabled = () => !!config.turnstileSiteKey;

// storableError() keeps `name` but drops unknown properties, so the name is
// what survives into Redux for isCaptchaError() to match on.
const captchaError = message => {
  const error = new Error(message);
  error.name = CAPTCHA_ERROR_CODE;
  error.captcha = true;
  return error;
};

/**
 * Ask our own API to validate a Turnstile token against Cloudflare.
 *
 * The secret key lives only on the server, so this round trip is what makes
 * the widget worth anything — a client-side check alone would just be edited out.
 */
export const verifyCaptchaToken = token => {
  if (!isCaptchaEnabled()) {
    return Promise.resolve({ success: true, skipped: true });
  }

  if (!token) {
    return Promise.reject(captchaError('Captcha token missing'));
  }

  return fetch(apiUrl + '/api/captcha/verify', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  })
    .then(response => response.json().catch(() => ({})))
    .then(data => {
      if (!data || data.success !== true) {
        throw captchaError(CAPTCHA_ERROR_CODE);
      }
      return data;
    })
    .catch(error => {
      // A network failure must not be treated as a pass.
      throw error.captcha ? error : captchaError(CAPTCHA_ERROR_CODE);
    });
};
